<template>
  <aside class="mb-4">
    <div class="row comments-header">
      <div class="col-6 d-flex align-items-center gap-3">
        <span class="sub-title pe-2">View</span>
        <p
          v-for="item in viewOptions"
          :key="item.text"
          :class="{ active: item.isPositive == allCommentsIsPositive }"
          @click="switchComments()"
          class="py-2 px-3 mb-0 cursor-pointer option-container"
        >
          {{ item.text }} comments
        </p>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end gap-3">
        <span class="sub-title pe-2">filter</span>
        <figure
          v-for="(item, index) of sidebarItems"
          class="d-flex align-items-center option-container py-2 px-3 mb-0 cursor-pointer"
          :key="item.icon"
          @click="filterComments(item.icon, index)"
          :class="{ active: item.checked }"
        >
          <img
            :src="require(`@/assets/images/comments-page/${item.icon}.svg`)"
            :alt="item"
            class="img-fluid"
            width="25"
          />
          <figcaption class="px-2">{{ item.icon }}</figcaption>
        </figure>
      </div>
    </div>

    <!-- <h3 class="filter-title text-capitalize mb-4">Summary Notes</h3>
    <input
      type="text"
      class="comment-textarea mb-2"
      v-model="note.title"
      placeholder="Title"
    />
    <textarea
      class="comment-textarea"
      rows="3"
      v-model="note.body"
      placeholder="Here you can jot down insights you see from these comments. Have fun!"
    ></textarea>
    <div class="text-end py-3">
      <button
        class="btn btn-light text-capitalize"
        @click="addNote()"
        :disabled="note.body == ''"
      >
        add note
      </button>
    </div> -->
    <!-- <div class="accordion accordion-flush" id="accordionFlushExample">
      <template v-for="(note, index) of commentsNotes">
        <edit-comment
          :key="'note-' + note.id"
          :note="note"
          :index="index + 1"
        ></edit-comment>
      </template>
    </div> -->
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
// import EditComment from "./edit-comment.vue";
export default {
  // components: { EditComment },
  data() {
    return {
      note: {
        title: "",
        body: "",
      },
      sidebarItems: [
        { icon: "starred", checked: false },
        { icon: "archived", checked: false },
        { icon: "all", checked: true },
      ],
      viewOptions: [
        { text: "positive", isPositive: true },
        { text: "negative", isPositive: false },
      ],
    };
  },
  computed: {
    ...mapGetters("mainStats", {
      commentsNotes: "getCommentsNotes",
      allCommentsIsPositive: "allCommentsIsPositive",
    }),
  },
  methods: {
    filterComments(type, index) {
      this.$emit("filter-comments", type);
      this.sidebarItems.forEach((element) => {
        element.checked = false;
      });
      this.sidebarItems[index].checked = true;
    },
    switchComments() {
      this.$store.dispatch("mainStats/toggleCommentsType");
    },
    async addNote() {
      let body = {
        surveyId: this.$route.params.id,
        ...this.note,
      };
      await this.$store.dispatch("mainStats/addCommentsNote", body);
      this.note = {
        title: "",
        body: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
aside {
  .note-container {
    border: 0.5px solid gray;
    padding: 10px;
    border-radius: 7px;
  }

  img {
    width: 1.5625rem;
  }
}
input,
textarea {
  &:focus::placeholder {
    color: $color-white !important;
  }
}

/////////////////////

.comments-header {
  .sub-title {
    font-weight: $font-weight-semiBold;
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .option-container {
    background: $color-grey-100;
    transition: all 0.3s;
    border: 1px solid $color-white;
    border-radius: 1.875rem;

    &.active {
      background: $color-white;
      color: $color-black;

      figcaption {
        color: $color-black;
      }
      img {
        filter: invert(1);
      }
    }
  }
}
</style>
